import {rootActions, useAppDispatch, useAppSelector} from "../DAL/store";
import React, {useEffect, useRef} from "react";
import {getIListItemByFreePluginItem} from "../services/parsing-provider";
import GridProduct from "../../products/product/grid-product";
import {initEqualHeight} from "../../list-page/services/list-page-provider";
import {useWindowSize} from "../../../domain/common";
import {getIsAuthenticated} from "../../../domain/hidden-data-provider";
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';


export const Products = () => {

    const dispatch = useAppDispatch();
    const PageData = useAppSelector(store => store.PageData);
    const filteredItems = useAppSelector(store => store.filteredItems);


    const size = useWindowSize();
    const containerRef = useRef<HTMLDivElement>(null);
    const imgCdnDomain =  useAppSelector(store => store.imgCdnDomain);

    const updateCampaignAndItemCode = (itemCode : string, itemDescription : string) => {
        const isUserLoggedIn = getIsAuthenticated();
        if(!isUserLoggedIn){
            //show login popup
            dispatch(
                rootActions.main({
                    isLoggedInForFreePlugin:true,
                    showLoginPage:true
                })
            );
        }else{
            //show EFS popup  in order to continue get free plugin process
            dispatch(
                rootActions.main({
                    isLoggedInForFreePlugin:false,
                    showEfsPopup: true,
                    itemCode:itemCode,
                    selectedItemDescription:itemDescription,
                    reply:"Confirm"
                })
            );
        }
    }
    /**
     * titles and taglines should have equal height in grid view
     */
    useEffect(() => {

        (async () => {
            if(size.width != null &&  PageData.freePlugins && PageData.freePlugins.length > 0) {
                await initEqualHeight(containerRef.current, size.width, 'grid', 5, 3, 2);
            }
        })();
    }, [
        // update on document width change
        size.width, PageData.freePlugins
    ]);


    return (
        <div ref={ containerRef }>
            {filteredItems.length > 0 &&
                <ul className={`grid gap-12  grid-cols-2 md:grid-cols-3 xl:grid-cols-5`}  >
                    {filteredItems.map((item, index) => {
                        let listItem = getIListItemByFreePluginItem(item,imgCdnDomain);
                        return (

                            <li key={item.skuNumber + '_' + index} className="">
                                <GridProduct
                                    product={listItem}
                                    removeTitleLink={true}
                                    removeImgLink={true}
                                    isPriceThirdRowHidden={false}
                                    isFirstMerchRowHidden={false}
                                    isPriceDiscountBadgeHidden={false}
                                    additionalContent={
                                        <div className="mt-3">
                                            <a  href={listItem.documentUrlPath} title={listItem.documentName} onClick={evt => {
                                                sendGAEvent('Free Plugins', 'Explore product');
                                            }}>Explore product</a>
                                        </div>

                                    }
                                >
                                    <div>
                                        <button
                                            type="button"
                                            className='w-btn-outline-black w-auto inline-block px-8 md:px-10'
                                            onClick={evt => {
                                                evt.preventDefault();
                                                updateCampaignAndItemCode(item.skuNumber, item.documentName);
                                                sendGAEvent('Free Plugins', 'Get Free');
                                            }}>Get Free</button>
                                    </div>

                                </GridProduct>
                            </li>

                        )
                    })}
                </ul>

            }

        </div>

    )
};